import useBaseIndex from "../../base/hooks/useBaseIndex";
import { HousekeepingV4ResponseSchema } from "../response/IndexHousekeepingV4Response";

const API_VERSION = "v4";

interface IndexHousekeepingV4Props {
    filters?: { [key: string]: any };
    search?: string;
    paginate?: number;
    page?: number;
    [key: string]: any;
}

const useIndexHousekeepingV4 = (query: IndexHousekeepingV4Props) =>
    useBaseIndex({
        ...query,
        queryKey: "housekeeping-list",
        endpoint: `${API_VERSION}/housekeeping`,
        schema: HousekeepingV4ResponseSchema,
    });

export default useIndexHousekeepingV4;